module.exports = __webpack_public_path__ + "static/3-339dcd81dd7b83e94c3b0b10a332b8e9.jpg";